import React from 'react';
import { useTranslation } from 'react-i18next';
import { FieldValues, UseFieldArrayAppend } from 'react-hook-form';
import Button, {
  ButtonSizes,
  ButtonTypes,
} from '@lib/components/Button/Button';
import { AppendValue } from '@lib/components/ReactHookForm/types';
import styles from './OptionsAddItemComponent.module.scss';

export interface OptionsAddItemComponentProps {
  append: UseFieldArrayAppend<FieldValues, string>;
  appendCallback: () => void;
  appendValue: AppendValue;
  buttonText?: React.ReactNode;
  isAddMoreVisible: boolean;
}

function OptionsAddItemComponent({
  append,
  appendCallback,
  appendValue,
  buttonText,
  isAddMoreVisible,
}: OptionsAddItemComponentProps) {
  const { t } = useTranslation();
  const onClick = () => {
    append(appendValue);
    if (appendCallback) appendCallback();
  };
  return (
    <div className={styles.addItemBtnWrapper}>
      <Button
        buttonSize={ButtonSizes.small}
        buttonText={buttonText || t('add-option')}
        buttonType={ButtonTypes.secondaryOutlined}
        disabled={!isAddMoreVisible}
        leftIcon="add"
        onClick={onClick}
      />
    </div>
  );
}

export default OptionsAddItemComponent;
